<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <section class="faq-page">
      <header class="header">
        <h2>{{ labelService.getLabel("frequent_questions") }}</h2>
        <app-button
          [text]="labelService.getLabel('contact_us')"
          (click)="toggleConctactUsPanel()"
          class="contact-button"
        ></app-button>
      </header>

      <!-- contact us panel -->
      @if (showContactUsPanel) {
        <div class="flex-container">
          <div class="contact-us-panel" @fadeSlide>
            <h2>{{ labelService.getLabel("contact_us") }}</h2>
            <textarea
              [(ngModel)]="messageText"
              placeholder="Scrivi qui il tuo messaggio..."
              rows="6"
            ></textarea>
            <div class="panel-buttons">
              <button
                class="button-white"
                mat-stroked-button
                (click)="toggleConctactUsPanel()"
              >
                {{ labelService.getLabel("close") }}
              </button>
              <button
                class="button-white"
                mat-stroked-button
                (click)="sendFeedback(messageText)"
                [disabled]="!messageText.trim()"
              >
                {{ labelService.getLabel("send") }}
              </button>
            </div>
          </div>
        </div>
      }

      <!-- list of questions -->
      <section class="questions">
        @for (faq of faqs; track faq) {
          <div class="category">
            <span class="category-title" (click)="toggleSelectedCategory(faq)">
              {{ faq.category }}
            </span>
            @if (faq.selected) {
              <div class="all-questions" @fadeSlide>
                @for (faqQuestion of faq.questions; track faqQuestion) {
                  <div
                    class="question"
                    [id]="
                      createSlug(faq.category) +
                      '--' +
                      createSlug(faqQuestion.question)
                    "
                  >
                    <span
                      class="question-title"
                      (click)="toggleSelectedQuestion(faqQuestion, faq)"
                      >{{ faqQuestion.question }}</span
                    >
                    @if (faqQuestion.selected) {
                      <div class="answer" @fadeSlide>
                        <span class="pre-wrap">{{ faqQuestion.answer }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </section>
    </section>
  </main>
</app-side-top-bar>
